export default "__VITE_ASSET__uB90USOr__"